import { connect } from 'react-redux'
import type { Dispatch } from 'redux'
import GiftCheckout from './GiftCheckout'
import type { PropsType, DispatchPropsType } from './GiftCheckout'
import type { AppStateType } from '../../../reducers/appstate'
import { changePlanAction } from '../../../actions/subscriptionActions'
import type { PurchaseGiftParamsType } from '../../../models/Gift'

type OwnPropsType = {
  purchasingGiftErrorMessage?: string,
  purchasingGift: boolean,
  giftCode?: string,
  completeOrder: (
    params: PurchaseGiftParamsType,
    name: string,
    stripe: any,
    cardElement: any
  ) => void,
  newPrice?: string,
  promoText?: string
}

const mapStateToProps = (state: AppStateType, ownProps: OwnPropsType): PropsType => {
  return {
    ...ownProps,
    subscriptionText: state.subscriptionText,
    featurePrideGift: state.featurePrideGift
  } as PropsType
}

const mapDispatchToProps = (dispatch: Dispatch<any>): DispatchPropsType => {
  return {
    setPlanLength: (planLength: 'six_months' | 'annual'): void => dispatch(changePlanAction(planLength, false, true))
  } as DispatchPropsType
}

export default connect(mapStateToProps, mapDispatchToProps)(GiftCheckout)
